let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("a05Bn")).then(() => parcelRequire('7AaHD'));